<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    align-content-start>
    <v-layout
      justify-center
      wrap>
      <v-flex>
        <formAdminAttestationAccountsDatatable
          :account-id="accountId"
          :type="'update'" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      valid: null,
      fullDetailForm: false,
      accountId: null,
      search: '',
      S3ObjectKey: '',
      Requestor_Email: '',
      LogsPagination: {
        descending: true,
        sortBy: 'Log_Id'
      },
      dates: {
        date_onboarded: false
      },
      mfaList: [
        'Vault0', 'Vault0eu', 'Vault0us', 'KeePass AU (KeeOTP)', 'KeePass US (KeeOTP) - Legacy',
        'KeePass EU (KeeOTP) - Legacy', 'Authy (MP)', 'Authy (Child) - Legacy',
        'Hardware key (acct owner)', 'None', 'Other'
      ],
      rcsList: [
        'Vault0', 'Vault0eu', 'Vault0us', 'KeePass Global (Legacy)', 'KeePass AU',
        'KeePass US - Legacy', 'KeePass EU - Legacy', 'KeePass (MP)', 'None', 'Other'
      ],
      emailRules: [
        v => {
          if (!v || v.length < 1)
            return 'Input is required';
          else if (v.length > 0) {
            for (let i = 0; i < v.length; i++) {
              if (!(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(v[i]))) {
                return 'Input must be valid email format';
              }
            }
          }
          else return true;
        }
      ],
      externalIdRules: [
        v => {
          if (!v || v.length < 20) return "External Id should be at least 20 characters"
        }
      ]
    }
  },
  computed: {},
  mounted () {
    this.$store.dispatch('admin/accountAttestation/getAttestationRequest')
  },
  methods: {
    downloadDocument() {
      this.$store.dispatch('admin/accountOnboarding/downloadDocument', this.S3ObjectKey)
    }
  }
}
</script>

<style lang="scss" scoped>
.full-detail-link {
  position: absolute;
  right: 20px;
}
.main-btn {
  width: 25px;
  height: 25px;
  border-radius: 50%;
}
</style>
